// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"9f754daa","352":"25c1cff5","363":"985180f7"}[chunkId] + ".chunk.js";
};